import { render } from "./FormManterDepartamento.vue?vue&type=template&id=74012f3c"
import script from "./FormManterDepartamento.vue?vue&type=script&lang=js"
export * from "./FormManterDepartamento.vue?vue&type=script&lang=js"

import "./FormManterDepartamento.vue?vue&type=style&index=0&id=74012f3c&lang=css"
/* custom blocks */
import block0 from "./FormManterDepartamento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__